import React from 'react';
import skill from '../../../img/Icons/Update/Skills.png'
import IconLarge from '../../GeneralSubcomponents/IconLarge'
import '../../../Styles/certifications.css'
import certifications from './certifications.json'
import Certification from './Certification'

const Certifications = () => (

    <div className="certificate">
        <div className="row o-icon-title"><IconLarge iconL={skill} /><p> &nbsp; Certifications</p></div>
        <div className="row o-certifications">
        {
            certifications.map(certification => (<Certification
            course={certification}
            ></Certification>) )
        }
        </div>
        
    </div>

);
export default Certifications;